<template>
  <div>
    <div class="name">{{ name }}</div>
    <div class="country">{{ country }}</div>
  </div>
</template>

<script>
export default {
  props: ['name', 'country'],
  name: 'ReferralCell'
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/referrals/referralCell.scss';
</style>
